const lang = {
    ja: {
        'home.title': 'ホームページ',
        'home.english': '英語',
        'home.japan': '日本人',
        'home.admissionApplication': '入場申込み',
        'home.loginViewer': '入場する',
        'home.exhibitApplication': '出展申込み',
        'home.loginExhibit': '出展作業する',
        'home.apply': '申込み済の方はこちら',
        'home.loginFree': 'フリー入場する',
        'home.textLoginFreeOnePage': '「フリー入場する」ボタンを押すと、{freeOnePage}が見られます。（入場申込みは不要です）',
        'home.textLoginFreeTwoPage': '「フリー入場する」ボタンを押すと、{freeOnePage}や{freeTwoPage}などが見られます。（入場申込みは不要です）',
        'home.textLoginFreeAllPage': '「フリー入場する」ボタンを押すと、{freeExhibition}、{freeSeminar}、{freeLivestream}が見られます。（入場申込みは不要です）',
        'home.textLoginRegister': '既に、{loginPage}へお申込みの方は「申込み済の方はこちら」ボタンよりログインしてください。',
        'home.textLoginRegisterTwoPage': '既に、{loginPage}・{loginTwoPage}へお申込みの方は「申込み済の方はこちら」ボタンよりログインしてください。',
        'home.textLoginNoRegister': 'まだお申込みされていない方は、【{loginPage}】より、ページ内下部にある「申込みする」ボタンよりお申込みいただけます。',
        'home.textLoginNoRegisterTwoPage': 'まだお申込みされていない方は、【{loginPage}/{loginTwoPage}】より、ページ内下部にある「申込みする」ボタンよりお申込みいただけます。',
        'home.textLogin': '入場申込み済みの方は（入場する）ボタンを押すと{textExhibit}、{textSeminar}、{textLivestream}が見られます。',
        'home.textRegisterViewer': 'もし「入場申込み」をしていない場合は（入場申込み）ボタンを押してください。',
        'home.textLoginExhibit': '出展申込み済みの方は（出展者業する）ボタンを押すと出展作業などができます。',
        'home.textRegisterOrganizer': 'もし「出展申込み」をしていない場合は（出展申込み）ボタンを押してください。',
        'home.textRegisterFail': '既に出展申し込み期限を過ぎているため、申し込みができません。',
        'home.textRegisterFailNote': 'ご了承ください。',
        'home.noteThanksViewer': 'ご来場ありがとうございます。',
        'home.noteThanksOrganizer': '出展ありがとうございます。',
        'home.overview': '概要',
        'home.guidelinesExhibitor': '出展募集要項',
        'home.displayProduct': '展示商品',
        'home.seminar': 'セミナー',
        'home.exhibition': '展示会',
        'login.password': 'パスワード',
        'login.email': '{email}を入力してください。',
        'login.notePassword': '管理者から発行されたパスワードを入力してください。',
        'login.guidelineViewer': '入場申し込みはこちらをクリック',
        'login.guidelineOrganizer': '出展申し込みはこちらをクリック',
        'exhibited.products': '展示商品',
        'login.seminars': 'セミナー',
    },
    en: {
        'home.title': 'Home Page',
        'home.english': 'ENGLISH',
        'home.japan': 'JAPAN',
        'home.admissionApplication': 'Application for entry',
        'home.loginViewer': 'Enter',
        'home.exhibitApplication': 'Apply for Exhibition',
        'home.loginExhibit': 'Prepare for Exhibition',
        'home.apply': 'Already Registered',
        'home.loginFree': 'Free Entry',
        'home.textLoginFreeOnePage': 'By clicking Free Entry button, you can view {freeOnePage}. (Application for entry is not required)',
        'home.textLoginFreeTwoPage': 'By clicking Free Entry button, you can view {freeOnePage}, {freeTwoPage}. (Application for entry is not required)',
        'home.textLoginFreeAllPage': 'By clicking Free Entry button, you can view {freeExhibition}, {freeSeminar} and {freeLivestream}. (Application for entry is not required)',
        'home.textLoginRegister': 'If you have already applied for {loginPage}, please login by clicking Already Registered button.',
        'home.textLoginRegisterTwoPage': 'If you have already applied for {loginPage} and {loginTwoPage}, please login by clicking Already Registered button.',
        'home.textLoginNoRegister': 'If you have not applied yet, click 【{loginPage}】 on the left pane -> Apply button at the bottom of the next screen to apply.',
        'home.textLoginNoRegisterTwoPage': 'If you have not applied yet, click 【{loginPage}/{loginTwoPage}】 on the left pane -> Apply button at the bottom of the next screen to apply.',
        'home.textLogin': 'If you have already applied for entry, click Enter button to view {textExhibit}, {textSeminar} and {textLivestream}.',
        'home.textRegisterViewer': 'If you have not applied for entry yet, click Apply for Entry button on the left.',
        'home.textLoginExhibit': 'If you have already applied for exhibition, click Prepare for Exhibition button to prepare for exhibition.',
        'home.textRegisterOrganizer': 'If you have not applied for exhibition yet, click Apply for Exhibition button on the left.',
        'home.textRegisterFail': 'Exhibition application deadline has passed. You cannot apply for the exhibition.',
        'home.textRegisterFailNote': 'Thank you for your understanding.',
        'home.noteThanksViewer': 'Thank you for coming.',
        'home.noteThanksOrganizer': 'Thank you for exhibiting.',
        'home.overview': 'Summary',
        'home.guidelinesExhibitor': 'Exhibition requirements',
        'home.displayProduct': 'Products to exhibit',
        'home.seminar': 'Seminar',
        'home.exhibition': 'exhibition',
        'login.password': 'Password',
        'login.email': 'Please enter your {email}.',
        'login.notePassword': 'Please enter the password issued by the administrator.',
        'login.guidelineViewer': 'To apply for entry, please click here.',
        'login.guidelineOrganizer': 'To apply for exhibition, please click here.',
        'exhibited.products': 'exhibited products',
        'login.seminars': 'seminars',
    },
};

export default lang;
